/**
 * Is the window large-ish?
 * @returns {Boolean} true if large, otherwise false.
 */
function isDesktop() {
    return window.innerWidth >= BREAKPOINTS.large;
}

const EmblaCarouselModule = require('embla-carousel');
const emblaCarousel = EmblaCarouselModule.default;

const emblaCategoryNode = document.getElementById('categoryRefinement');
const BREAKPOINTS = {
    med: 768,
    large: 1024
};
if (emblaCategoryNode) {
    const viewportNode = emblaCategoryNode.querySelector('.embla__category__viewport');


    const selectedOption = $('span.refinement-category.selected[id]').first()
    const selectedOptionId = selectedOption.attr('id');
    let index = 0;

    if (selectedOptionId) {
        index = parseInt(selectedOptionId.split('-').pop()) - 1;
    }

    const customAlign = (viewSize, snapSize, alignIndex) => {
        return index === 0 || 20
    };

    const OPTIONS = {
        align: customAlign,
        dragFree: true,
        startIndex: index,
    };

    if (!isDesktop()) {
        emblaCarousel(viewportNode, OPTIONS);
    } else {
        const categoriesRefinement = $('div#category-refinement-container')
        categoriesRefinement.remove();
    }
}
